<template>
  <div class="login">
    <van-loading type="spinner" vertical>加载中...</van-loading>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data() {
    return {
      url: ''
    }
  },
  created() {
    // const type = this.$route.query.type || 0
    // localStorage.setItem('tabbarActive', type)
    const loginQueryStr = localStorage.loginQuery || ''
    const loginQuery = loginQueryStr && JSON.parse(loginQueryStr)
    const query = this.$route.query
    if (query.openid) {
      localStorage.clear()
      localStorage.setItem('openId', query.openid)
      localStorage.removeItem('loginQuery')
      const params = { ...loginQuery }
      delete params.url
      const toUrl = loginQuery?.url || '/'
      if (toUrl === 'tMap') {
        window.location.href = '/tMap'
      } else {
        this.$router.push({ path: toUrl, query: params })
      }
    } else {
      localStorage.setItem('loginQuery', JSON.stringify(query))
      this.wechatAuthorize()
    }
  },
  methods: {
    wechatAuthorize() {
      const returnUrl = `${window.location.protocol}//${window.location.host}/login`
      this.$Apis.wechatAuthorize({ returnUrl }).then(res => {
        if (res.code === 200) {
          window.location.href = res.data.url
        } else {
          this.$('请重新进入')
        }
      }).catch((err) => {
        this.$toast('服务器错误', JSON.stringify(err))
      })
    }
  }
}
</script>
<style lang="less" scoped>
.login{
  /deep/.van-loading{
    text-align: center;
    margin-top: 1rem;
  }
}
</style>
